import { AbstractControl, Validators } from "@angular/forms";

export class CpfValidator {
    static isValid(control: AbstractControl): { [key: string]: boolean } | null {
        if (control.value) {

            var cpf = control.value.replace(/[^\d]+/g, '');

            if (cpf == '') return {
                "invalid-cpf": true
            };

            if (cpf.length != 11)
                return {
                    "invalid-cpf": true
                };

            // Elimina CPFs invalidos conhecidos
            if (cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999")
                return {
                    "invalid-cpf": true
                };

            let numeros: any, digitos: string, soma: number, i: number, resultado: number, digitos_iguais: number;
            digitos_iguais = 1;
            for (i = 0; i < cpf.length - 1; i++)
                if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
                    digitos_iguais = 0;
                    break;
                }
            if (!digitos_iguais) {
                numeros = cpf.substring(0, 9);
                digitos = cpf.substring(9);
                soma = 0;
                for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado.toString() !== digitos.charAt(0))
                    return {
                        "invalid-cpf": true
                    };
                numeros = cpf.substring(0, 10);
                soma = 0;
                for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado.toString() !== digitos.charAt(1))
                    return {
                        "invalid-cpf": true
                    };
                return null;
            } else {
                return {
                    "invalid-cpf": true
                };
            }
        } else {
            if (!control.hasValidator(Validators.required)) {
                return {};
            }
            return {
                "invalid-cpf": true
            };
        }
    }
}
